module.exports = __webpack_public_path__ + "static/media/drop1.36ee2625.svg";